import type { KeyResultUnitValue } from '@/constants/KeyResultUnit';
import type { IconProps } from '@amelio/ui-library';

import { KeyResultUnit } from '@/constants/KeyResultUnit';

/** Glyph shown in the round tile at the head of a measurement card, one per key-result unit. */
export const KEY_RESULT_UNIT_ICON: Record<KeyResultUnitValue, IconProps['name']> = {
    [KeyResultUnit.NUMBER]: 'programming-hashtag',
    [KeyResultUnit.PERCENTAGE]: 'money-percentage-square',
    [KeyResultUnit.MONETARY]: 'money-dollar-circle',
    [KeyResultUnit.YES_NO]: 'essential-checkmark',
};
